export enum PreviewType {
  IMAGE = 'image',
  VIDEO = 'video',
  AUDIO = 'audio',
  OFFICE = 'office',
  PDF = 'pdf',
  TEXT = 'text',
}

const PREVIEWABLE_MIME_TYPES: Record<PreviewType, string[]> = {
  [PreviewType.IMAGE]: ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/svg+xml'],
  [PreviewType.VIDEO]: ['video/mp4', 'video/webm'],
  [PreviewType.AUDIO]: ['audio/mpeg', 'audio/wav'],
  [PreviewType.OFFICE]: [
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/vnd.ms-powerpoint',
    'application/vnd.oasis.opendocument.text',
    'application/vnd.oasis.opendocument.spreadsheet',
    'application/vnd.oasis.opendocument.presentation',
  ],
  [PreviewType.PDF]: ['application/pdf'],
  [PreviewType.TEXT]: ['text/plain', 'text/csv', 'application/json', 'text/xml', 'application/xml'],
};

const OFFICE_VIEWER_BASE_URL = 'https://view.officeapps.live.com/op/view.aspx';

export function getPreviewType(contentType: string): PreviewType | null {
  const lower = contentType.toLowerCase();
  for (const [type, mimeTypes] of Object.entries(PREVIEWABLE_MIME_TYPES)) {
    if (mimeTypes.some((mime) => lower === mime)) {
      return type as PreviewType;
    }
  }
  return null;
}

export function isPreviewable(file: { latestVersion?: { contentType?: string } | null }): boolean {
  return getPreviewType(file.latestVersion?.contentType ?? '') !== null;
}

export function buildPreviewUrl(sasUri: string, previewType: PreviewType): string {
  if (previewType === PreviewType.OFFICE) {
    return `${OFFICE_VIEWER_BASE_URL}?src=${encodeURIComponent(sasUri)}`;
  }
  return sasUri;
}
